// extracted by mini-css-extract-plugin
export default {"tooltip__label":"ElementTooltipLabelSingle_tooltip__label__V3SvY"};